import React from "react";
import AuthForm from "./components/AuthForm";
import AuthInfo from "./components/AuthInfo";
import AuthHeader from "./components/AuthHeader";
import SEO from "../../components/SEO";

const Auth = () => {
  return (
    <>
      <SEO 
        title="Login - Acesse sua Conta | Grupo Terra"
        description="Acesse sua conta no Grupo Terra para visualizar produtos, fazer pedidos e gerenciar sua conta."
        keywords="login, acesso, conta, cliente"
      />
      <div className="container">
        <AuthHeader />
        <div className="row row-cols-lg-2 row-cols-sm-1 mb-5">
          <AuthForm />
          <AuthInfo />
        </div>
      </div>
    </>
  );
};
export default Auth;
